import { render, staticRenderFns } from "./SurveyManagementQuestionWrapper.vue?vue&type=template&id=17667ad1&scoped=true&"
import script from "./SurveyManagementQuestionWrapper.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementQuestionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementQuestionWrapper.vue?vue&type=style&index=0&id=17667ad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17667ad1",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementQuestionWrapper.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17667ad1')) {
      api.createRecord('17667ad1', component.options)
    } else {
      api.reload('17667ad1', component.options)
    }
    module.hot.accept("./SurveyManagementQuestionWrapper.vue?vue&type=template&id=17667ad1&scoped=true&", function () {
      api.rerender('17667ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/SurveyManagementQuestionWrapper.vue"
export default component.exports